import React from 'react';
import LogoUrl from './encompass-admin.svg';

function logo() {
    return <img className="header__logo" src={LogoUrl} alt="Encompass Corporation"/>;
}

export default logo;
